import {scopedHandler} from 'utils/redux';
import {getFormValues} from 'redux-form';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';
import {computeCondosQuery} from './utils';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize(payload)];
		}
		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.filter.type: {
			const filterForm = getFormValues('filterForm')(fullState);
			const sortForm = getFormValues('sortForm')(fullState);

			const condosQuery = computeCondosQuery({filterForm, sortForm});

			return [{...state, condosQuery, processing: true}, effects.updateCondos()];
		}

		case actions.clearFormFields.type: {
			const form = getFormValues(payload)(fullState);
			const formName = payload;
			return [state, effects.clearFormFields({form, formName})];
		}

		case actions.changeLane.type: {
			const condoQuery = {...state.condoQuery, lane: payload};
			return [{...state, currentLane: payload, condoQuery}, null];
		}

		case actions.navigateToCondo.type: {
			const projectBuildingId = payload[0];
			const options = payload[2] || {};
			return [state, effects.navigateToCondo([projectBuildingId, options])];
		}

		case actions._initialize.type: {
			const {condos: condosData, condosQuery, lane, areaCounties, users} = payload;
			const {data: condos, meta: condosMeta} = condosData;

			return [
				{
					...state,
					initialized: true,
					currentLane: lane,
					areaCounties,
					progressData: condos,
					condosMeta,
					condosQuery,
					users,
				},
				null,
			];
		}

		case actions._setCondos.type: {
			const {data: condos, meta: condosMeta} = payload;
			return [{...state, progressData: condos, condosMeta, processing: false}, null];
		}

		case actions._opFailed.type: {
			return [{...state, processing: false}, null];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
